import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.header`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    width: 100%;
    height: 80px;
    z-index: 3;

    .logo {
      background: ${theme.colors.white};
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
      position: fixed;
      left: 0;
      height: 80px;
      width: 81px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: end;
    width: calc(100% - 220px);

    > .verified-email {
      display: flex;
      align-items: center;
      text-decoration: none;
      border: 1px solid ${theme.colors.darkYellow};
      background: ${theme.colors.lightYellow};
      border-radius: 50%;
      padding: 8px;
      margin-right: 18px;
      margin-top: 3px;
      transition: filter ${theme.transition.default};
      cursor: pointer;

      > svg {
        width: 20px;
        height: 20px;
      }

      &:hover {
        filter: brightness(0.9);
      }
    }

    .tooptip-warning-custom {
      opacity: 1 !important;
      text-align: center;
      max-width: 260px;
      box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
      border-radius: ${theme.border.radius};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
    }

    .menu {
      background: transparent;
      border-radius: 0.2rem;
      color: ${theme.colors.primary};
      height: 40px;
      width: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid transparent;
      transition: 0.1s;
      cursor: pointer;

      ::after {
        content: '';
        display: block;
        width: 1.2rem;
        height: 2px;
        border-radius: 2px;
        background: currentColor;
        box-shadow: 0 6px currentColor, 0 -6px currentColor;
        transition: 0.2s;
      }
    }

    .name-user {
      background: transparent;
      color: ${theme.colors.primary};
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.light};
      font-size: ${theme.font.sizes.medium};
      cursor: pointer;

      ::after {
        content: '';
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${theme.colors.darkGray};
        border-radius: 6px;
        font-size: 2px;
        margin-left: 15px;
      }
    }

    ${media.lessThan('small')`
      width: calc(100% - 110px);

      >a {
        margin-left: 100px;
      }

      .verified-email{
        display: none;
      }

      .name-user{
        font-size: ${theme.font.sizes.xxsmall};
        text-align: center;
        width: 152px;
      }
    `}
  `}
`

export const DropdownMenu = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 279px;
    height: 200px;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
    border-radius: ${theme.border.radius};
    position: absolute;
    top: 89px;
    right: 116px;
    background: ${theme.colors.white};
    animation: dropMenu 0.3s ease-in-out;

    ::after {
      content: '';
      margin: 0 auto;
      width: 0;
      height: 0;
      border-right: 22px solid transparent;
      border-top: 22px solid transparent;
      border-left: 22px solid transparent;
      border-bottom: 22px solid ${theme.colors.white};
      position: absolute;
      top: -44px;
      right: 123px;
    }

    .dropdown-title {
      background: linear-gradient(
        358.25deg,
        rgba(229, 229, 229, 0.68) 19.64%,
        #ffffff 75.78%
      );
      padding: 10px 14px 10px;
      height: 60px;
      border-radius: ${theme.border.radius} ${theme.border.radius} 0 0;

      p {
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.xxxsmall};
        margin-top: 0;
        margin-bottom: 6px;
      }

      p + p {
        font-size: 12px;
        margin: 0;
      }
    }

    .dropdown-content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      position: relative;
      margin-top: 5px;
      height: 30%;
      cursor: pointer;
      transition: ${theme.transition.default};

      :hover {
        svg,
        h4,
        h5,
        p {
          color: ${theme.colors.primary};
          filter: brightness(0.8);
        }
      }

      svg {
        position: absolute;
        top: 17px;
        left: 12px;
      }

      h4 {
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.bold};
        font-size: ${theme.font.sizes.xxxsmall};
        padding: 10px 0 0 50px;
      }

      h5 {
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.bold};
        font-size: ${theme.font.sizes.xxxsmall};
        padding: 23px 0 0 50px;
      }

      p {
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.semiBold};
        font-size: 12px;
        padding: 0 0 0 50px;
        margin-top: 4px;
      }

      .dropdown-link {
        text-decoration: none;
        color: ${theme.colors.black};
      }

      .dropdown-logout {
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: baseline;
        background: transparent;
        height: 100%;
        color: ${theme.colors.black};
        padding-bottom: 1.2rem;
        cursor: pointer;
      }
    }

    ${media.lessThan('small')`
      right: 0;
    `}

    @keyframes dropMenu {
      from {
        top: 0;
        opacity: 0;
      }
      to {
        opacity: 1;
        top: 89px;
      }
    }
  `}
`
